import { render, staticRenderFns } from "./iconFocus.vue?vue&type=template&id=18dd7b0a"
import script from "./iconFocus.vue?vue&type=script&lang=js"
export * from "./iconFocus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports